export default __webpack_public_path__ + "static/media/fastDice-icon.3fc4bff1.svg";